import { NgModule } from '@angular/core';
import { PermissionBadgeDirective } from './directives';

@NgModule({
  imports: [PermissionBadgeDirective],
  exports: [PermissionBadgeDirective],
})
export class PermissionsModule {}
